<script setup lang="ts">
const props = defineProps({
  context: Object,
})

const parent = computed(() => props.context.node.parent._value)
</script>

<template>
  <div class="flex items-center h-full bg-gray-100 rounded-lg px-4">
    {{ context.setValue(parent) }}
  </div>
</template>
